(() => {
  const initCollectionHeroToggle = () => {
    document.querySelectorAll('[data-collection-hero-toggle]').forEach((button) => {
      if (button.dataset.collectionHeroToggleReady === 'true') return;
      button.dataset.collectionHeroToggleReady = 'true';

      const hero = button.closest('.collection-hero.has-description');
      if (!hero) return;

      const setState = (open) => {
        hero.classList.toggle('active', open);
        button.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        button.setAttribute('aria-label', open ? 'Close collection information' : 'Open collection information');
        button.textContent = open ? '×' : 'i';
      };

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        setState(!hero.classList.contains('active'));
      }, true);

      hero.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !button.matches(':focus-visible')) {
          setState(false);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionHeroToggle);
  } else {
    initCollectionHeroToggle();
  }

  document.addEventListener('shopify:section:load', initCollectionHeroToggle);
})();
